( function () {
	'use strict';

	function indicatorService () {
		var indicators = {};

		function getViewData ( key ) {
			return angular.copy( indicators[ key ].data );
		}

		function getData ( key ) {
			var editData = getViewData( key );

			return editData;
		}

		function getConfig ( key ) {
			var editData = getViewData( key );

			return {
				'path' : editData.path,
				'type' : editData.type
			};
		}

		function register ( key, indicator ) {
			indicators[ key ] = indicator;
		}

		function getIndicators () {
			// get copy of indicator list for processing
			var indicatorCopy = {};

			// access all elements from indicator list
			Object.keys( indicators ).map( function ( indicatorKey ) {
				// check if element is to be displayed
				if ( !indicators[ indicatorKey ].isHidden ) {
					// add to indicator copy
					indicatorCopy[ indicatorKey ] = indicators[ indicatorKey ];
				}
			} );
			return indicatorCopy;
		}

		function reset () {
			indicators = {};
		}

		return {
			'reset'         : reset,
			'getData'       : getData,
			'register'      : register,
			'getConfig'     : getConfig,
			'getIndicators' : getIndicators
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'indicatorService', indicatorService );
} )( );
